module.exports = __webpack_public_path__ + "img/bg_tech_lamp@2x.a9edca5a.jpg";